import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps } from '@material-ui/core';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './SGSSelect.module.scss';

export type OptionType<T = string> = {
    value: T;
    label: string | JSX.Element;
};

export type SGSSelectProps = SelectProps & {
    options: OptionType<string>[];
    helperText?: string;
    name: string;
};

const SGSSelectCtr: React.FC<SGSSelectProps> = ({ children, label, id, name, options, error, helperText, multiple, value, ...props }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const errorPath = name.split('.');
    const hasError = errorPath.reduce((obj, key) => obj && obj[key], errors);

    return (
        <FormControl variant={props.variant} error={hasError ? true : false} fullWidth={props.fullWidth}>
            {label && <InputLabel htmlFor={id || name}>{typeof label === 'string' ? t(label) : label}</InputLabel>}
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <Select
                        {...field}
                        {...props}
                        id={id || name}
                        label={label}
                        multiple={multiple}
                        value={field.value || ''}
                        onChange={(e, child) => {
                            props.onChange ? props.onChange(e, child) : field.onChange(e.target.value);
                        }}
                        open={open}
                        MenuProps={{
                            classes: { list: styles.menu },
                            getContentAnchorEl: () => null,
                        }}
                        onClose={handleClose}
                        onOpen={handleOpen}
                    >
                        {options.map((o) => (
                            <MenuItem key={o.value} value={o.value} classes={{ root: styles.menuItem, selected: styles.menuItem__selected }}>
                                {typeof o.label === 'string' ? t(o.label) : o.label}
                            </MenuItem>
                        ))}
                        <Box textAlign="center">
                            {multiple && (
                                <Button color="primary" onClick={handleClose} variant="contained">
                                    {t('global.ok')}
                                </Button>
                            )}
                        </Box>
                    </Select>
                )}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
            {hasError && <FormHelperText error>{hasError.message}</FormHelperText>}
        </FormControl>
    );
};

export default SGSSelectCtr;
